<template>
  <section>
    <!--Cabeçalho de consulta-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form ref="formRule" :model="formRule" label-width="80px" size="mini">
        <el-col :span="12">
          <el-form-item label="CNPJ">
            <el-select style="width:274px" v-on:change="cleanListaNfe" v-model="formRule.cnpjSel"
              placeholder="Selecione o CNPJ">
              <el-option v-for="item in formRule.cnpjObj" :key="item.cnpj" :label="item.apelido" :value="item.cnpj">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Período">
            <el-date-picker style="width:135px" v-on:change="cleanListaNfe" v-model="formRule.dtIni" type="date"
              value-format="yyyy-MM-dd" format="dd/MM/yyyy" align="center" placeholder="Data inicial">
            </el-date-picker>
            <el-date-picker style="width:135px" v-on:change="cleanListaNfe" v-model="formRule.dtFin" type="date"
              value-format="yyyy-MM-dd" format="dd/MM/yyyy" align="center" placeholder="Data Final">
            </el-date-picker>
          </el-form-item>
          <!-- descrEmitDest -->
          <el-form-item label="Emit./Dest.">
            <el-tooltip class="item" effect="dark"
              content="Permite buscar as NF-e de um emitente/destinatário específico." placement="bottom">
              <el-input style="width:274px" v-mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="formRule.cnpjEmitDest" v-on:change="cleanListaNfe" clearable
                placeholder="CPF/CNPJ do emitente/destinatário"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tipo">
            <el-radio-group v-model="formRule.tipo" v-on:change="changeDescr">
              <!-- <el-radio-button label="T">Todas</el-radio-button> -->
              <el-radio-button label="E">Emitidas</el-radio-button>
              <el-radio-button label="R">Recebidas</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Situação">
            <el-radio-group v-model="formRule.situacao" v-on:change="cleanListaNfe">
              <el-radio-button label="T">Todas</el-radio-button>
              <el-radio-button label="N">Autorizadas</el-radio-button>
              <el-radio-button label="C">Canceladas</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading=formRule.listLoading
              @click.native.prevent="getListaNfe(null, null)">Buscar</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>

    <!--Tabela de dados-->
    <table-nfe :lista-nfe=formRule.listaNfe :list-loading=formRule.listLoading :descr-emit-dest=formRule.descrEmitDest
      :total-reg=formRule.totalReg @getlistnfe="getListaNfe"></table-nfe>
  </section>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask"; // https://vuejs-tips.github.io/vue-the-mask/
import tableNfe from "../../components/table-nfe.vue";
import { apiGetCnpj, apiGetListaNfeGeral } from "../../api/api";

// const dtAtual = new Date();
const dtAtual = new Date().toISOString().substring(0, 10);
export default {
  components: {
    tableNfe
  },
  directives: {
    mask
  },
  data () {
    return {
      formRule: {
        dtIni: dtAtual,
        dtFin: dtAtual,
        cnpjEmitDest: "",
        tipo: "E",
        situacao: "T",
        cnpjObj: [],
        cnpjSel: "",
        listaNfe: [],
        descrEmitDest: "Destinatário",
        totalReg: 0,
        listLoading: false,
        pageSize: 10
      }
    };
  },
  methods: {
    changeDescr () {
      if (this.formRule.tipo === "E") {
        this.formRule.descrEmitDest = "Destinatário";
      } else {
        this.formRule.descrEmitDest = "Emitente";
      }
      this.cleanListaNfe();
    },
    cleanListaNfe () {
      this.formRule.listaNfe = [];
      this.formRule.totalReg = 0;
    },
    getListaNfe (pageNumber, pageSize) {
      this.formRule.listLoading = true;
      if (!pageSize) {
        this.formRule.totalReg = 0;
      }
      // Valida se campos data estao nulos
      if (!this.formRule.dtIni) {
        this.formRule.dtIni = dtAtual;
      }
      if (!this.formRule.dtFin) {
        this.formRule.dtFin = dtAtual;
      }

      //Remove formatacao do CPF/CNPJ
      const cpfCnpjEmitenteDestinario = this.formRule.cnpjEmitDest
        .replace(/\./g, "")
        .replace(/\-/g, "")
        .replace(/\//g, "");

      let params = {};
      params["cnpj"] = this.formRule.cnpjSel;
      params["tipoConsulta"] = "geral";
      params["dataInicial"] = this.formRule.dtIni + "T00:00:00";
      params["dataFinal"] = this.formRule.dtFin + "T00:00:00";
      params["tipo"] = this.formRule.tipo;
      params["situacao"] = this.formRule.situacao;
      params["cpfCnpjEmitenteDestinario"] = cpfCnpjEmitenteDestinario;
      if (pageSize && pageSize >= 0) {
        this.formRule.pageSize = pageSize;
      }
      params["limit"] = this.formRule.pageSize;

      if (pageNumber && pageNumber >= 0) {
        params["page"] = pageNumber;
      } else {
        params["page"] = 1;
      }

      this.formRule.listaNfe = [];
      apiGetListaNfeGeral(params)
        .then(res => {
          this.formRule.listaNfe = res;
          this.formRule.totalReg = parseInt(res[0].totalReg);
          this.formRule.listLoading = false;
        })
        .catch(error => {
          this.formRule.listLoading = false;
        });
    }
  },
  mounted () {
    var user = localStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      const cnpj = user.cnpj || "";
      // this.sysUserAvatar = user.avatar || ""
      apiGetCnpj(cnpj)
        .then(data => {
          this.formRule.cnpjObj = data;
          this.formRule.cnpjSel = data[Object.keys(data)[0]].cnpj;
        })
        .catch(error => {
          console.log(error);
        });
      //
      // this.getListaNfe()
    }
  }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/consulta-nfe/geral.vue